import React, {useState} from 'react';

import {Button, Modal} from 'antd';

import {FormularioPessoas} from './formulario-pessoas';

const FormularioPessoasModal = ({ title, getApi, buttonOpts, tipoPessoa='Cliente', onAfterSave = (pessoaSalva)=> {}}) => {

    const [modalVisivel, setModalVisivel] = useState(false);
    const [salvarFuncs, setSalvarFunc] = useState([]);
    const [saving, setSaving] = useState(false);

    const {icon, text, type, size} = buttonOpts
    
    
    const abrirModal = () => {
        setModalVisivel(true);
    }

  
    
    const onSaveHandle = async(evt) => {
        
        setSaving(true);

        const tamFunc = salvarFuncs.length;
        for(let i=0; i < tamFunc; i++){
            const func = salvarFuncs[i];
            try{
                await func();
            } catch(e){
                console.log(e)
            }
        }
        setSaving(false);
        
        setModalVisivel(false);
    }

    const registraSalvarFunc = salvarFunc => {
        const funcs = [].concat(salvarFuncs, salvarFunc);
        setSalvarFunc(funcs);
    }
    
    return <div>
                <Button onClick={abrirModal} icon={icon} type={type} size={size}>{text}</Button>
                <Modal 
                    visible={modalVisivel} 
                    onOk={onSaveHandle} 
                    title={ title || "Salvar Cliente" }
                    style={{ top: 20 }}
                    width="calc(100% - 10vw)"
                    okText="Salvar"
                    cancelText="Cancelar"
                    onCancel={() => setModalVisivel(false)}
                    confirmLoading={saving}
                    tipoPessoa={tipoPessoa}
                    >
                    <FormularioPessoas 
                        registraSalvarFunc={registraSalvarFunc}
                        getApi={getApi}
                        onAfterSave={onAfterSave}
                    ></FormularioPessoas>
                </Modal>
        </div>;
};

export {FormularioPessoasModal};